<template>
  <div :class="classObj">

    <section class="sidebar-container" v-if="isShow" :class="[isShowCss ? 'sidebar-container2':'']">
      <div class="logo_box">
        <!-- <img src="../../assets/img/logoMiniL.png" alt="" class="logo">
        <img src="../../assets/img/logoMiniR.png" alt="" :class="['logo_txt',{'hide': isCollapse}]"
             style="margin-left:4px;"> -->
      </div>
      <sub-nav :isCollapse="isCollapse" :submenuAll="submenuAll" :exData='exData'></sub-nav>
    </section>


    <section class="main-container" :class="[isShowCss ? 'main-container2':'']">
      <div :class="['header', isCollapse ? 'longNav': 'shortNav', isShowCss ? 'header2':'']" v-if="isShow">
        <hamburger :toggle-click="toggleSideBar" :is-active="!isCollapse" class="hamburger-container"
                   v-if="!unCollapsable" :applyModel="exData.applyModel"/>
        <div v-else></div>
        <h1 class="title">数智化学院管理后台</h1>
        <div placement="bottom-end">
<!--          <ul class="pop_menu">-->
<!--            <li @click="logout">退出</li>-->
<!--          </ul>-->
          <div class="user_info" slot="reference">
            {{empno}}
            {{username}}
            <!-- <img src="../../assets/images/p_header.jpg" alt="" class="header_img"> -->
          </div>
        </div>

      </div>
      <section class="container-box">
        <router-view></router-view>
      </section>

    </section>
  </div>
</template>

<script>

  import Hamburger from '@/components/Hamburger'
  import {MainNav, SubNav} from './components'
  import Icon from 'vue-svg-icon/Icon.vue';
  import {debounce} from '@/utils'
  import {logoutFromP13} from "@/api/oauth";
  import Cookies from 'js-cookie'

  export default {
    name: 'HelloWorld',
    data() {
      return {
        unCollapsable: false,
        isCollapse: false,
        isShow: true,
        isShowCss: false,
        sidebar: {
          opened: true
        },
        path: '/home',
        activeSubMenu: 'home',
        activeSubMenuTitle: '',
        submenuAll: {
          home: []
        },
        username: "admin",
        empno:'',
        exData: {
          applyModel: ''
        },
        role_id: 1,
      };
    },
    created() {
      if(JSON.parse(localStorage.getItem('users')) != null){
        this.username = JSON.parse(localStorage.getItem('users')).username;
      }
      this.empno = Cookies.get("empno")
      this.submenuAll.home = JSON.parse(localStorage.getItem('routers'))
      // this.getPathInfo();
    },
    mounted() {

      // this.__resizeHandler = debounce(() => {
      //     if (document.body.clientWidth < 1200) {
      //         this.isCollapse = true;
      //         this.unCollapsable = true;
      //     }else{
      //         this.unCollapsable = false;
      //     }
      // }, 100);
      // if (document.body.clientWidth < 1200) {
      //     this.isCollapse = true;
      //     this.unCollapsable = true;
      // }else{
      //     this.unCollapsable = false;
      // }
      // window.addEventListener('resize', this.__resizeHandler);
      const cookies = Cookies;
      // get_zhs_token().then(resp => {
      //   const res = resp.data
      //   cookies.set('zhs_token', res.token)
      //   cookies.set('iframe_host', res.iframe_host)
      // })

    },
    beforeDestroy() {
      // window.removeEventListener('resize', this.__resizeHandler);
    },
    watch: {
      $route: {
        handler: function (val, oldVal) {
          this.getPathInfo()
          this.aioIsShowNav()
        },
        deep: true
      }
    },
    computed: {
      classObj() {
        return {
          'app-wrapper': true,
          hideSidebar: this.isCollapse,
          openSidebar: !this.isCollapse,
        };
      }
    },
    methods: {

      toggleSideBar() {
        if (!this.unCollapsable) {
          this.isCollapse = !this.isCollapse;
        }
      },
      getPathInfo() {
        // this.activeMainMenu = this.$route.path.split('/')[1]||'home';
        // this.activeSubMenu = this.$route.path.split('/')[2] || this.submenuAll[this.activeMainMenu][0].pathName;
        // this.activeSubMenuTitle = this.submenuAll[this.activeMainMenu].filter(item=> {
        //     return item.pathName === this.activeSubMenu;
        // })[0].title;
      },
      aioIsShowNav() {
        console.log(this.$route.path)
        let paths = this.$route.path
        if (paths === '/hotel/aio') {
          this.isShow = false
          this.isShowCss = true
        } else {
          this.isShow = true
          this.isShowCss = false
        }
      },
      logout() {
        // Cookies.remove('token');
        // Cookies.remove('empno');
        // localStorage.removeItem('users');
        // localStorage.removeItem('routers');
        // localStorage.clear();
        // this.$router.push({path: '/login'})

        //退出登录
        logoutFromP13().then(resp => {
          if (resp.errcode == 200) {
            Cookies.remove('token');
            Cookies.remove('empno');
            localStorage.removeItem('users');
            localStorage.removeItem('routers');
            localStorage.clear();
            this.$router.push({path: '/login',query:{type:'77899653'}})
          } else {
            this.$message.error(resp.errmsg);
          }
        })
      },
    },
    components: {
      Icon,
      SubNav,
      MainNav,
      Hamburger
    },
  }
</script>
<style lang="scss" scoped>
  .header2 {
    display: none!important;
  }
  .sidebar-container2 {
    display: none!important;
  }
  .main-container2 {
    margin: 0!important;
    padding: 0!important;
  }
  .app-wrapper {
    position: relative;
    height: 100%;
    width: 100%;
    // min-width: 1200px;
    .sidebar-container {
      transition: width 0.28s;
      height: 100%;
      position: fixed;
      font-size: 0px;
      top: 0;
      bottom: 0;
      left: 0;
      z-index: 1001;
      overflow-y: scroll;
      overflow-x: hidden;
      height: 100%;
      // width: 256px;
      background: #004B8A;
      border-bottom: solid 1px #EBEEF5;
      &::-webkit-scrollbar {
        display: none;
      }
      .logo_box {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 72px;
        -webkit-transition: height .28s .1s;
        transition: height .28s .1s;
        // background: #303851;
        border-bottom: solid 1px rgba(255,255,255,0.3);
        img {
          height: 36px;
        }
        .logo_txt {
          -webkit-transition: height .28s .1s;
          transition: height .28s .1s;
          &.hide {
            height: 0;
          }
        }
      }
    }

    .main-container {
      position: relative;
      height: calc(100vh);
      -webkit-transition: margin-left .28s;
      transition: margin-left .28s;
      margin-left: 200px;
      background: #EBEEF5;
      overflow-y: scroll;
      padding-top: 65px;
      overflow-x: hidden;
      .header {
        position: fixed;
        top: 0;
        left: 65px;
        right: 0;
        display: flex;
        height: 65px;
        justify-content: space-between;
        align-items: center;
        padding: 0 24px 0 18px;
        background: rgba(255, 255, 255, 1);
        border-bottom: solid 1px #EBEEF5;
        z-index: 10002;
        -webkit-transition: left .28s;
        transition: left .28s;
        &.longNav {
          left: 64px;
        }
        &.shortNav {
          left: 200px;
        }
        .title {
          width: 100%;
          padding-left: 15px;
          font-size: 28px;
        }
        .hamburger-box {
          flex-shrink: 0;
          flex-grow: 0;
        }
        .user_info {
          font-size: 18px;
          white-space: nowrap;
          .header_img {
            width: 45px;
            height: 45px;
            margin-left: 15px;
            border-radius: 45px;
            vertical-align: middle;
          }
        }

      }
      .container-box {
        padding: 0 24px 24px;
        .breadcrumb_wrap {
          padding: 15px 0;
        }
      }
    }
    footer {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
      line-height: 20px;
      padding: 10px;
      text-align: center;
    }

    &.openSidebar {
      position: fixed;
      top: 0;
    }

  }

  #app .hideSidebar .main-container {
    margin-left: 64px;
  }

  .pop_menu li {
    font-size: 16px;
    line-height: 2.5;
    text-align: center;
    border-bottom: solid 1px #f1f1f1;
    cursor: pointer;
    &:hover {
      color: #409EFF;
    }
    &:last-child {
      border-bottom: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue